/**
 * To show content in turnover dorpdown
 */
export const TURNOVER_CONTENT = [
  {
    id: 'Same as annual business turnover',
    labelText: 'Same as annual business turnover'
  },
  {
    id: '0 - 100k',
    labelText: '0 - 100k'
  },
  {
    id: '100k - 200k',
    labelText: '100k - 200k'
  },
  {
    id: '200k - 300k',
    labelText: '200k - 300k'
  },
  {
    id: '500k - 1m',
    labelText: '500k - 1m'
  },
  {
    id: '1m - 2m',
    labelText: '1m - 2m'
  },
  {
    id: '2m - 3.5m',
    labelText: '2m - 3.5m'
  },
  {
    id: '3.5m - 4.5m',
    labelText: '3.5m - 4.5m'
  },
  {
    id: '4.5m - 6.5m',
    labelText: '4.5m - 6.5m'
  },
  {
    id: 'Over 6.5m',
    labelText: 'Over 6.5m'
  }
];

/**
 * To show content in cash deposit select dropdown
 */
export const CASH_DEPOSIT_CONTENT = [
  { id: '0 - 1K', labelText: '0 - 1K' },
  { id: '1K - 2K', labelText: '1K - 2K' },
  { id: '2K - 3K', labelText: '2K - 3K' },
  { id: '3K - 4K', labelText: '3K - 4K' },
  { id: '4K - 5K', labelText: '4K - 5K' },
  { id: '5K - 10K', labelText: '5K - 10K' },
  { id: '10K - 15K', labelText: '10K - 15K' },
  { id: '15K - 20K', labelText: '15K - 20K' },
  { id: '20K - 25K', labelText: '20K - 25K' },
  { id: '25K - 30K', labelText: '25K - 30K' },
  { id: '30K - 40K', labelText: '30K - 40K' },
  { id: '40K - 50K', labelText: '40K - 50K' },
  { id: '50K - 60K', labelText: '50K - 60K' },
  { id: '60K - 70K', labelText: '60K - 70K' },
  { id: '70K - 80K', labelText: '70K - 80K' },
  { id: '80K - 90K', labelText: '80K - 90K' },
  { id: '90K - 100K', labelText: '90K - 100K' },
  { id: '100K - 125K', labelText: '100K - 125K' },
  { id: '125K - 150K', labelText: '125K - 150K' },
  { id: '150K - 175K', labelText: '150K - 175K' },
  { id: '175K - 200K', labelText: '175K - 200K' },
  { id: '200K - 225K', labelText: '200K - 225K' },
  { id: '225K - 250K', labelText: '225K - 250K' },
  { id: '250K - 300K', labelText: '250K - 300K' },
  { id: '300K - 350K', labelText: '300K - 350K' },
  { id: '350K - 400K', labelText: '350K - 400K' },
  { id: '400K - 450K', labelText: '400K - 450K' },
  { id: '450K - 500K', labelText: '450K - 500K' },
  { id: '500K - 550K', labelText: '500K - 550K' },
  { id: '550K - 600K', labelText: '550K - 600K' },
  { id: '600K - 650K', labelText: '600K - 650K' },
  { id: '650K - 700K', labelText: '650K - 700K' },
  { id: '700K - 750K', labelText: '700K - 750K' },
  { id: '750k - 1M', labelText: '750k - 1M' },
  { id: '1M - 1.5M', labelText: '1M - 1.5M' },
  { id: '1.5M - 2M', labelText: '1.5M - 2M' },
  { id: 'Over 2m', labelText: 'Over 2m' }
];

/**
 * To show this content in payment duration select dropdown
 */

export const PAYMENT_DURATIONS = [
  {
    id: 'DAILY',
    labelText: 'Daily'
  },
  {
    id: 'WEEKLY',
    labelText: 'Weekly'
  },
  {
    id: 'MONTHLY',
    labelText: 'Monthly'
  },
  {
    id: 'OCCASIONALLY',
    labelText: 'Occasionally'
  }
];
